import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../modules/users/users.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: true
})
export class FooterComponent implements OnInit {

  constructor(public userService: UsersService) { }

  ngOnInit() {
  }

}
